<template>
    <div>
        <input class="w-full outline-none p-1" v-focus="v-focus" v-model="search" @keydown.up="moveUp"
               @keydown.down="moveDown" @keydown.enter="enter" @input="inRange"/>
        <div class="text-xs italics">{{ filter.length }} result(s) found</div>
        <ul class="list-none overflow-scroll" style="max-height: 180px">
            <li class="p-1 pl-8 cursor-pointer hover_bg-primary-200" v-if="addNone" @click="clear">None</li>
            <li class="p-1 pl-8 cursor-pointer hover_bg-primary-200" v-for="(item, index) in limit"
                @click="click(item)">{{ item.value }}
            </li>
            <li class="text-sm p-1 pl-8" v-if="limit.length < filter.length">Apply search to see more...</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        value: Number,
        data: Array,
        addNone: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        search: '',
        selected: 0
    }),
    computed: {
        limit() {
            return this.filter.slice(0, 500)
        },
        filter() {
            var s = this.search.toLowerCase()
            return this.data.filter(f => f.value?.toLowerCase().includes(s))
        }
    },
    methods: {
        inRange() {
            if (this.selected < 0) {
                this.selected = this.filter.length - 1
            }
            if (this.selected > this.filter.length - 1) {
                this.selected = 0
            }
        },
        moveUp() {
            this.selected--;
            this.inRange()
        },
        moveDown() {
            this.selected++;
            this.inRange()
        },
        enter() {
            this.click(this.filter[this.selected])
        },
        click(item) {
            this.$emit('select', item)
        },
        clear() {
            this.$emit('select', null)
        }
    }
}
</script>

